// import { useContext, useEffect } from "react";
// import { Select } from "ol/interaction";
// import MapContext from "../Map/MapContext";
// //import GeoJSON from "ol/format/GeoJSON";
// //import ShowParcelInfoDialog from "../ShowParcelInfoDialog";


// const SelectInteraction = ({setSelectedFeature, showPopup=false}) => {
// 	const { map } = useContext(MapContext);
// 	useEffect(() => {
// 		if (!map) return;

// 		let selectInteraction = new Select({});
		
// 		selectInteraction.on('select', (event) => {
// 		  const selectedFeatures = event?.selected;// Access selected features here//  console.log(selectedFeatures);

// 			setSelectedFeature(selectedFeatures ? selectedFeatures: null);
// 			if(showPopup){
// 				return
// //				<ShowParcelInfoDialog />
// //console.log(selectedFeatures);
// 			//	var format = new GeoJSON();
// 							/*var geojson1 = format.writeFeaturesObject([
// 								event?.selected[0],
// 							]);*/
// 			}
// 		});
// 		map.interactions.push(selectInteraction);

// 		return () => map.interactions.remove(selectInteraction);
// 	}, [map]);

// 	return null;
// };

// export default SelectInteraction;

import { useContext, useEffect, useRef } from "react";
import { Select } from "ol/interaction";
import MapContext from "../Map/MapContext";

const SelectInteraction = ({ setSelectedFeature, showPopup = false }) => {
  const { map } = useContext(MapContext);
  const selectInteractionRef = useRef(null);

  useEffect(() => {
    if (!map) return;

    // Remove any existing select interactions
    const existingInteractions = map.getInteractions().getArray();
    existingInteractions.forEach(interaction => {
      if (interaction instanceof Select) {
        map.removeInteraction(interaction);
      }
    });

    // Create basic select interaction
    const selectInteraction = new Select({
      hitTolerance: 5,
      style: null, // Let CommonLayers handle styling
    });
    
    selectInteractionRef.current = selectInteraction;

    selectInteraction.on('select', (event) => {
      // Prevent any default browser behavior
      if (event.mapBrowserEvent) {
        event.mapBrowserEvent.preventDefault();
        event.mapBrowserEvent.stopPropagation();
      }
      
      const selectedFeatures = event?.selected;
      
      // Just update state - this will trigger popup but NOT move map
      setSelectedFeature(selectedFeatures && selectedFeatures.length > 0 ? selectedFeatures : null);
      
      // Log for debugging
      if (selectedFeatures && selectedFeatures.length > 0) {
        console.log("Feature selected - view will NOT change");
      }
    });

    map.addInteraction(selectInteraction);

    return () => {
      if (selectInteractionRef.current) {
        map.removeInteraction(selectInteractionRef.current);
      }
    };
  }, [map, setSelectedFeature]);

  return null;
};

export default SelectInteraction;